import React from "react";
import FieldBuilder from "../fields/fields-builder";
import { buildSpacerFields } from "./helpers/container-spacers";

export default (fields, appData, components, screen) => {
  const lastOfKind = [];
  for (let i = 0; i < fields.length - 1; i++) {
    lastOfKind.push(fields[i].type !== fields[i + 1].type);
  }
  lastOfKind.push(true);

  const fieldTypes = fields.map(field => field.type);
  const onlyOfKind = fieldTypes.map(
    fieldType => fieldTypes.filter(type => type === fieldType).length === 1
  );
  const fieldsToRender = buildSpacerFields(fields, appData) || fields;

  return fieldsToRender.map((field, index) => {
    const key = field.fieldKey ?? `field_${field.name}`;

    return (
      <FieldBuilder
        key={key}
        lastOfKind={lastOfKind[index]}
        onlyOfKind={onlyOfKind[index]}
        field={field}
        appData={appData}
        components={components}
        screen={screen}
      />
    );
  });
};
